import React from 'react';
import PropTypes from 'prop-types';

const TableCellCollapse = ({ children, dataLabel, ...otherProps }) => (
  <td data-label={dataLabel} {...otherProps}>
    {children}
  </td>
);

TableCellCollapse.defaultProps = {
  children: null,
};

TableCellCollapse.propTypes = {
  children: PropTypes.node,
  dataLabel: PropTypes.string.isRequired,
};

export default TableCellCollapse;
